{
  "version": 1,
  "asset_id": "679dd82d-b3ff-4bc3-99e9-8f0605a561a3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/679dd82d-b3ff-4bc3-99e9-8f0605a561a3/sleeve-excess-weight-loss-percentage-graph-720.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/679dd82d-b3ff-4bc3-99e9-8f0605a561a3/sleeve-excess-weight-loss-percentage-graph-720.webp",
  "original_filename": "sleeve-excess-weight-loss-percentage-graph-720.webp",
  "size": 14098,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:09:29Z"
}
